const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay, addWheelControls } =
  window.BAO.Carousel.plugins

class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.link?.exists) {
      this.handleLinkClick = this.handleLinkClick.bind(this)

      this.els.link.elements.forEach((link) => {
        this.listeners.add(link, 'click', this.handleLinkClick)
      })
    }

    if (!this.els?.dismiss?.exists) return

    this.handleDismiss = this.handleDismiss.bind(this)
    this.listeners.add(this.els.dismiss.element, 'click', this.handleDismiss)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useAutoplay(this.autoplay, { pauseOnHover: true }),
        addWheelControls('horizontal'),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.currentIndex = currentSlide

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  handleLinkClick (event) {
    const text = event.currentTarget.getAttribute('aria-label')

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'announcement_bar_interaction',
      target_text: text,
      target_index: this.currentIndex,
    })
  }

  async handleDismiss () {
    this.classList.toggle('sec-AnnouncementBar-hidden')

    await window.BAO.Cart.updateCartAttributes({
      dismissed_announcement: this.announcementId,
    })
  }

  get autoplay () {
    return parseInt(this.dataset.autoplay)
  }

  get announcementId () {
    return this.dataset.announcementId
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
